module.exports = __webpack_public_path__ + "static/media/Team1.8bc4c464.jpg";